import type { AxiosRequestConfig } from 'axios';

// TODO: Remove this helper and its endpoint call sites once the backends own
// x-auth-token handling and frontend requests no longer need to set the header.
export async function getAuthenticationConfig(): Promise<Pick<AxiosRequestConfig, 'headers'>> {
  const tokens = await globalThis.ikea.mvAgent.authentication?.getTokens();
  const token = tokens?.auth.value ?? tokens?.guest?.value;
  return token ? { headers: { 'x-auth-token': token } } : {};
}
